var map = {
	"./bicycle.svg": 35817,
	"./bus.svg": 19596,
	"./businesscar.svg": 21290,
	"./car.svg": 29572,
	"./excavator.svg": 97009,
	"./excavator2.svg": 36113,
	"./plain.svg": 50042,
	"./ship.svg": 81744,
	"./suv.svg": 3540,
	"./transportmixer.svg": 87076,
	"./truck.svg": 47215,
	"./van.svg": 31633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77173;